var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from "react";
import { checkEva } from "@jti/fe-common";
import { AemPDPMappingApiImpl } from "@jti/rest-api";
import { prepareProductLink } from "./prepareProductLink/prepareProductLink";
export const usePdpLink = (sku) => {
    const [pdpLink, setPdpLink] = useState("");
    const getPdpLink = useCallback((sku) => __awaiter(void 0, void 0, void 0, function* () {
        const isEva = checkEva();
        if (isEva) {
            return yield prepareProductLink(sku);
        }
        return yield AemPDPMappingApiImpl.init().getLinkBySku(sku);
    }), []);
    useEffect(() => {
        getPdpLink(sku).then((response) => {
            setPdpLink(response);
        });
    }, [sku, getPdpLink]);
    return pdpLink;
};
//# sourceMappingURL=usePdpLink.js.map